import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAralComponent } from './simple-icons-aral.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAralComponent ],
    exports:      [ SimpleIconsAralComponent ],
    bootstrap:    []
})
export class SimpleIconsAralModule {}
